import React from 'react';
import { Scan } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Footer({ onNavigate, currentPage }) {
  const navigate = useNavigate();

  const links = [
    { label: 'Inicio', key: 'home' },
    { label: 'Blog', key: 'blog' },
    { label: 'Precios', key: 'precios' },
    { label: 'API', key: 'api-docs' },
    { label: 'Quiénes somos', key: 'quienes-somos' },
    { label: 'Privacidad', key: 'privacidad' },
    { label: 'Términos', key: 'terminos' },
    { label: 'Cookies', key: 'cookies' },
  ];

  const handleClick = (key) => {
    if (key === 'blog') {
      navigate('/blog');
    } else if (key === 'home') {
      if (typeof onNavigate === 'function') {
        onNavigate('home');
      } else {
        navigate('/');
      }
    } else if (typeof onNavigate === 'function') {
      onNavigate(key);
    } else {
      // From blog routes: pass the target page via state so App can pick it up
      navigate('/', { state: { page: key } });
    }
  };

  return (
    <footer className="relative z-10 border-t border-zinc-800 bg-zinc-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
          <button onClick={() => handleClick('home')} className="flex items-center gap-2 hover:opacity-80 transition-opacity">
            <Scan className="w-5 h-5 text-blue-500" />
            <span className="font-heading font-black text-sm">VERITAS <span className="text-blue-500">SCAN</span></span>
            <span className="text-zinc-600 text-xs font-mono ml-2">Copyright © 2026</span>
          </button>
          <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1">
            {links.map(({ label, key }) => (
              <button
                key={key}
                onClick={() => handleClick(key)}
                className={`transition-colors font-mono text-xs ${
                  currentPage === key
                    ? 'text-blue-400'
                    : 'text-zinc-600 hover:text-zinc-400'
                }`}
              >
                {label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
